import { j as m } from "../../jsx-runtime-Wav_3Wde.js";
import { s as i } from "../../index.esm-DOxVcNnO.js";
import { forwardRef as p } from "react";
import { styled as c, css as d } from "styled-components";
import { compose as l, color as f, typography as g, space as h } from "styled-system";
const u = /* @__PURE__ */ c.h1.withConfig({
  shouldForwardProp: (o) => i(o)
}).withConfig({
  componentId: "sc-92b6ed79-0"
})([
  "",
  " ",
  ""
], ({ theme: o, size: s }) => /* @__PURE__ */ d([
  "",
  " ",
  ""
], o.components.heading.base, o.components.heading[s]), l(f, g, h)), b = /* @__PURE__ */ p(({ level: o = "1", size: s, textAlign: e = "center", ...r }, t) => {
  const a = s || [
    "huge",
    "large",
    "medium",
    "small",
    "xSmall"
  ][o] || "xSmall", n = `h${o}`;
  return /* @__PURE__ */ m.jsx(u, {
    as: n,
    ref: t,
    size: a,
    textAlign: e,
    ...r
  });
});
export {
  u as StyledHeading,
  b as default
};
